module.exports = __webpack_public_path__ + "img/security.912ecb25.svg";